import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Modal,
  ModalOverlay,
  ModalContent,
  Checkbox,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import icontrash from "../../assets/images/product/trash.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconBack from "../../assets/images/quailai.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import FormDetail from "./form/detail";
import FormInfo from "./form/info";
import { useBookingManagement } from "../../hooks/useBookingManagement";
import { useCategories } from "../../categorys/bookingManagement/index";
import toast from "react-hot-toast";
import { bookingCall } from "../../api/booking";
import { commonCall } from "../../api/common";
import { bookingImageCall } from "../../api/bookingImage";
import DeleteDialog from "../../components/dialog/delete";
import { GetLockings } from "../../utils/contants";
import DatePicker from "react-datepicker";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import FormReport from "./form/report";
import iconArrowLeft from "../../assets/images/arrow-left.svg";
import IconX from "../../assets/images/booking/x-circle.svg";
import { memo } from "react";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const TableBookingManagement = ({ isRefetchingWithCreate, setParamExport }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenTypeImage,
    onOpen: onOpenTypeImage,
    onClose: onCloseTypeImage,
  } = useDisclosure();
  const {
    isOpen: isOpenDelete,
    onOpen: onOpenDelete,
    onClose: onCloseDelete,
    // onToggle: onToggleDelete,
  } = useDisclosure();
  const {
    isOpen: isOpenReport,
    onOpen: onOpenReport,
    onClose: onCloseReport,
    // onToggle: onToggleReport,
  } = useDisclosure();

  const [zIndex, setZIndex] = useState(1);
  const [search, setSearch] = useState("");
  const [isAddBooking, setIsAddBooking] = useState(false);
  const [projectId, setProjectId] = useState([]);
  const [isLocking, setIsLocking] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [customerTypeId, setCustomerTypeId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [bookingEventId, setBookingEventId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [dataDel, setDataDel] = useState(null);
  const [status, setStatus] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);
  const [dataId, setDataId] = useState(null);
  const [typeImage, setTypeImage] = useState([]);

  const [dateRangeBooking, setDateRangeBooking] = useState([null, null]);
  const [startDateBooking, endDateBooking] = dateRangeBooking;
  // const [apartmentId, setApartmentId] = useState([]);

  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });
  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );
  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );
  const bookingEvents = useMemo(
    () => formatEntries(constantData?.bookingEvent),
    [constantData?.bookingEvent]
  );
  const customerTypes = useMemo(
    () => formatEntries(constantData?.customerType),
    [constantData?.customerType]
  );
  const customers = useMemo(() => {
    if (!constantData?.customer) return [];

    return Object.entries(constantData.customer).map(
      ([id, { fullName, phone, identificationNumber }]) => ({
        key: id,
        value: `${fullName}`,
        phone,
        identificationNumber,
      })
    );
  }, [constantData?.customer]);

  const saleBlockLists = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  const saleAreaLists = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );

  // const apartments = useMemo(
  //   () => formatEntries(constantData?.apartment),
  //   [constantData?.apartment]
  // );

  const statusDatas = [
    {
      key: "NEW",
      value: "Chưa duyệt",
    },
    {
      key: "REJECTED",
      value: "Không được phê duyệt",
    },
    {
      key: "APPROVED",
      value: "Đã được duyệt",
    },
    {
      key: "REFUND",
      value: "Đã hoàn trả",
    },
    {
      key: "EDITING",
      value: "Yêu cầu chỉnh sửa",
    },
    {
      key: "PENDINGRETURNREQUEST",
      value: "Yêu cầu hoàn booking",
    },
  ];

  const {
    bookingManagementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useBookingManagement(
    debouncedSearchTerm,
    projectId,
    employeeId,
    bookingEventId,
    status,
    isLocking,
    customerTypeId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
    startDateBooking,
    endDateBooking
    // apartmentId
  );

  useEffect(() => {
    setParamExport({
      search: debouncedSearchTerm,
      projectId,
      employeeId,
      bookingEventId,
      status,
      isLocking,
      customerTypeId,
      customerId,
      startDate,
      endDate,
      saleBlockId,
      saleAreaId,
      startDateBooking,
      endDateBooking
    });
  }, [
    setParamExport,
    debouncedSearchTerm,
    projectId,
    employeeId,
    bookingEventId,
    status,
    isLocking,
    customerTypeId,
    customerId,
    startDate,
    endDate,
    saleBlockId,
    saleAreaId,
    startDateBooking,
    endDateBooking
  ]);

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  // console.log(bookingManagementData)
  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Đã lên locking",
        key: "statusLocking",
      },
      {
        label: "Tên khách hàng",
        key: "nameCustomer",
      },
      // {
      //   label: "Phân loại",
      //   key: "customerType",
      // },
      {
        label: "Mã căn",
        key: "codeApartment",
      },
      {
        label: "Tên dự án",
        key: "nameProject",
      },
      {
        label: "Ngày booking",
        key: "bookingTime",
      },
      {
        label: "Đợt nhận booking",
        key: "bookingEvent",
      },
      {
        label: "Số tiền booking",
        key: "price",
      },
      {
        label: "Nhân viên tạo booking",
        key: "nameBooker",
      },
      {
        label: "Khối",
        key: "saleBlock",
      },
      {
        label: "Vùng",
        key: "saleArea",
      },
      {
        label: "Thời gian tạo Booking",
        key: "createdAt",
      },
    ],
    data: bookingManagementData,
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  // table
  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsAddBooking(type);
    onOpen();
  };

  const handleEdit = (type, e) => {
    setDataEdit(e?.detail);

    setIsAddBooking(type);
    onOpenDelete();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa booking ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      const { id, delegationImage, createdAt, nameBooker, ...dataFilter } =
        filteredData;

      delete dataFilter?.images;

      const dataCreateBooking = await bookingCall.update(id, {
        ...dataFilter,
      });

      if (dataCreateBooking?._id) {
        if (delegationImage && delegationImage.length > 0) {
          await bookingImageCall.createMany({
            bookingId: dataCreateBooking?._id,
            path: delegationImage,
            type: "TRANSACTION",
          });
        }
      }

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  // const onSubmitReport = async (data) => {
  //   console.log(data)
  // }

  const handleOpenDeleteBooking = (data) => {
    setDataDel(data);
  };

  const handleOpenReportBooking = (data) => {
    setDataEdit(data);
    onOpenReport();
  };

  const handleCloseDeleteBooking = () => {
    setDataDel(null);
  };
  const onSubmitDelete = async () => {
    const toastDelete = toast.loading("Đang xóa booking ...");
    try {
      const { id } = dataDel;
      await bookingCall.delete(id);
      await refetch();
      setDataDel(null);
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastDelete);
  };

  const submitStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await bookingCall.approve(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const revertStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await bookingCall.revert(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const refundStatus = async () => {
    const { id } = dataEdit;

    if (id) {
      const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
      const dataFormat = {
        status: "REFUND",
      };

      try {
        await bookingCall.refund(id, dataFormat);
        await refetch();
        onCloseDelete();
        toast.success("Cập nhập trạng thái thành công");
      } catch (error) {
        console.error("Error:", error);
        if (
          error?.response?.data?.status === 404 &&
          error?.response?.data?.message
        ) {
          // toast.error(error?.response?.data?.message);
        } else {
          toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
        }
      }
      toast.dismiss(toastEdit);
    }
  };

  const acceptRefund = async (status, id) => {
    if (id) {
      const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
      const dataFormat = {
        status: status || "REFUND",
      };

      try {
        await bookingCall.acceptRefund(id, dataFormat);
        await refetch();
        onCloseDelete();
        toast.success("Cập nhập trạng thái thành công");
      } catch (error) {
        console.error("Error:", error);
        if (
          error?.response?.data?.status === 404 &&
          error?.response?.data?.message
        ) {
          // toast.error(error?.response?.data?.message);
        } else {
          toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
        }
      }
      toast.dismiss(toastEdit);
    }
  };

  const getTypeImage = async (id) => {
    const toastCreate = toast.loading("Đang lấy danh sách ảnh booking ...");
    try {
      const data = await bookingCall.getTypeImage(id);
      if (data?.items) {
        setTypeImage(data?.items);
        onOpenTypeImage();
      }
      setDataId(id);
      await refetch();
      toast.success("Lấy danh sách ảnh thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };
  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Tên người tạo, khách hàng, sản phẩm, dự án "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <SearchableSelectMulti
                  isShowSearch={false}
                  options={statusDatas}
                  // initialSelectedOption={{
                  //   key: null,
                  //   value: "Trạng thái booking",
                  // }}
                  placeholder={"Trạng thái booking"}
                  setValue={setStatus}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={GetLockings}
                  initialSelectedOption={{
                    key: 0,
                    value: "Trạng thái lên locking",
                  }}
                  setValue={setIsLocking}
                />

                {/* <SearchableSelectMulti
                isShowSearch={true}
                options={apartments}
                // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
                placeholder={"Chọn mã căn"}
                setValue={setApartmentId}
              /> */}

                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  setValue={setProjectId}
                  placeholder={"Chọn dự án"}
                />
                <SearchableSelect
                  isShowSearch={false}
                  options={bookingEvents}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn đợt nhận booking",
                  }}
                  setValue={setBookingEventId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={customers}
                  initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
                  setValue={setCustomerId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={customerTypes}
                  initialSelectedOption={{ key: 0, value: "Loại khách hàng" }}
                  setValue={setCustomerTypeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOption={{
                    key: 0,
                    value: "Chọn nhân viên tạo",
                  }}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlockLists}
                  initialSelectedOption={{
                    key: null,
                    value: "Chọn khối",
                  }}
                  setValue={setSaleBlockId}
                // minW={"249px"}
                />

                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreaLists}
                  initialSelectedOption={{
                    key: null,
                    value: "Chọn vùng",
                  }}
                  setValue={setSaleAreaId}
                // minW={"249px"}
                />
                <InputGroup w={"100%"} maxW={"255px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày tạo từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDateBooking}
                    endDate={endDateBooking}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRangeBooking(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày booking từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDateBooking && !endDateBooking && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "15%";
                          textAlign = "start";
                        } else if (e.key === "nameProject") {
                          width = "20%";
                          textAlign = "start";
                        } else if (e.key === "nameCustomer") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameBookingEvent") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "price") {
                          width = "10%";
                          textAlign = "end";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else if (
                          e.key === "timeDelivery" ||
                          e.key === "timeStart" ||
                          e.key === "timeEnd"
                        ) {
                          width = "5%";
                          textAlign = "end";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenReportBooking(e?.edit)
                                    }
                                  >
                                    <Image src={iconDetail} /> Phản hồi booking
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => getTypeImage(e?.id)}
                                  >
                                    <Image src={iconArrowLeft} /> Tải ảnh
                                    Booking
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleOpenDeleteBooking(e?.edit)
                                    }
                                  >
                                    <Image src={icontrash} /> Xóa booking
                                  </MenuItem>
                                  {e?.status !== "REFUND" && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() => handleEdit(true, e)}
                                    >
                                      <Image src={iconBack} /> Hoàn booking
                                    </MenuItem>
                                  )}
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "nameProject") {
                                width = "20%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "250px";
                              } else if (keyvalue === "codeApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameCustomer") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameBookingEvent") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "codeProduct") {
                                width = "10%";
                                textAlign = "start";
                              } else if (
                                keyvalue === "timeDelivery" ||
                                keyvalue === "timeStart" ||
                                keyvalue === "timeEnd"
                              ) {
                                width = "5%";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }

                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                        e[keyvalue],
                                        keyvalue,
                                        submitStatus,
                                        e.id,
                                        revertStatus
                                      )
                                      : keyvalue === "statusRefund"
                                        ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          acceptRefund,
                                          e.id,
                                          revertStatus
                                        )
                                        : formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isAddBooking ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          value={dataEdit}
          refetch={refetch}
        />
      )}
      <DeleteDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
        title="Hoàn booking"
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn hoàn trả booking này không?"
          </Flex>
        }
        action={() => refundStatus()}
        textDelete="Hoàn booking"
      />

      {dataDel && (
        <DeleteDialog
          isOpen={!!dataDel}
          onClose={handleCloseDeleteBooking}
          title={"Xóa booking"}
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa booking{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataDel?.name}
              </Text>{" "}
              này không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}

      <FormReport
        isOpen={isOpenReport}
        onClose={onCloseReport}
        isEdit={true}
        defaultValues={dataEdit}
      // onSubmit={onSubmitReport}
      />

      <TableTypeImage
        isOpen={isOpenTypeImage}
        onClose={onCloseTypeImage}
        id={dataId || ""}
        defaultValues={typeImage}
      />
    </>
  );
};

const TableTypeImage = memo(({ isOpen, onClose, id, defaultValues }) => {
  const [value, setValue] = useState([]);
  const [dataValue, setDataValue] = useState([]);

  useEffect(() => {
    setValue(defaultValues);
    setDataValue([]);
  }, [defaultValues]);

  const downloadPDF = async (id) => {
    const toastCreate = toast.loading("Đang tải ảnh booking ...");
    try {
      const payload = dataValue
        .map((id) => value.find((item) => item.id === id))
        .filter(Boolean);

      const data = await bookingCall.downloadPDF(id, { input: payload });
      if (data?.fileUrl) {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = `${baseURL}${data?.fileUrl}`;
        link.click();
        if (document.body.contains(link)) {
          document.body.removeChild(link);
        }
      }
      toast.success("Tải ảnh thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <Box>
          <Box
            paddingBottom={"80px"}
            h={"86.5vh"}
            w={"100%"}
            sx={{
              "&::-webkit-scrollbar": {
                width: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
              "&::-moz-scrollbar": {
                width: "4px",
              },
              "&::-moz-scrollbar-thumb": {
                width: "4px",
                borderRadius: "50px",
                background: "var(--color-background)",
              },
            }}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Danh sách ảnh Booking
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
            >
              {value.map((item, index) => {
                const isChecked = dataValue.includes(item.id);
                return (
                  <Flex
                    key={index}
                    align="center"
                    borderBottom="1px solid var(--border-input-employee)"
                    _hover={{ background: "#f9fafd" }}
                  >
                    <Checkbox
                      p={2}
                      w={"100%"}
                      isChecked={isChecked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setDataValue((prev) => [...prev, item.id]);
                        } else {
                          setDataValue((prev) =>
                            prev.filter((i) => i !== item.id)
                          );
                        }
                      }}
                    >
                      {item?.name || ""}
                    </Checkbox>
                  </Flex>
                );
              })}
            </Box>
          </Box>
          {dataValue && dataValue?.length > 0 && (
            <Box
              position={"absolute"}
              w={"100%"}
              bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={() => downloadPDF(id)}
                >
                  Tải ảnh xuống
                </Button>
              </Flex>
            </Box>
          )}
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default TableBookingManagement;
